<template>
  <div class="distance-bar-container">
        <div class="progress progress-tooltip" style="height:20px">
            <div 
                class="progress-bar progress-bar-tooltip" 
                :class="textClass"
                role="progressbar" 
                :style="{width: percentage + '%'}" 
                :aria-valuenow="distance" 
                aria-valuemin="0" 
                :aria-valuemax="maxDistance">
                
                    {{ label }}
        
            </div>
        </div>
        <div class="progress" style="height:5px">
            <div 
                class="progress-bar" 
                :class="barClass"
                role="progressbar" 
                :style="{width: percentage + '%'}" 
                :aria-valuenow="distance" 
                aria-valuemin="0" 
                :aria-valuemax="maxDistance">
            </div>
        </div>
  </div>
</template>

<script>
export default {
    props:{
        distance:{
            type: Number,
            required: true
        },

        maxDistance:{
            type: Number,
            required: true
        },

        label:{
            type: String,
            required: true
        },

        barClass:{
            type:String
        },

        textClass:{
            type:String
        },
    },
    computed:{
        percentage(){
            return  this.maxDistance ? (this.distance * 100) / this.maxDistance : 0;
        }
    }
}
</script>

<style>

</style>